import { render, staticRenderFns } from "./ListToDos.vue?vue&type=template&id=191eb4cc&scoped=true&"
import script from "./ListToDos.ts?vue&type=script&lang=ts&"
export * from "./ListToDos.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191eb4cc",
  null
  
)

export default component.exports
import {QTable,QToggle,QCard,QCardSection,QBtn,QTr,QTd,QMenu,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QToggle,QCard,QCardSection,QBtn,QTr,QTd,QMenu,QDialog})
